import CheckboxField from './CheckboxField.component';

export default CheckboxField;
